import { Text } from '@dixa/lib-shared-habla';

export function RoutedThroughFinish(): JSX.Element {
  return <Text.Paragraph>Automation finished</Text.Paragraph>;
}
